<template>
  <v-form
    @submit.prevent="handleLogin"
    :errorMessages="errors.detail"
    v-if="!passwordReset"
  >
    <v-alert v-if="emailSent" dense text type="success"
      >If the email you entered is associated with a valid account you will
      receive an email with a new link shortly.</v-alert
    >
    <v-card-title class="headline" primary-title>Login</v-card-title>
    <v-card-text>
      <v-alert
        dense
        outlined
        type="error"
        v-if="errors.detail"
        v-html="errors.detail"
      ></v-alert>
      <v-text-field
        v-model="username"
        prepend-icon="mdi-account"
        name="email"
        label="Email"
        type="text"
        :outlined="outlined"
        :dense="dense"
        :errorMessages="errors.username"
      ></v-text-field>
      <v-text-field
        v-model="password"
        id="password"
        prepend-icon="mdi-lock"
        name="password"
        label="Password"
        type="password"
        :outlined="outlined"
        :dense="dense"
        :errorMessages="errors.password"
      ></v-text-field>
    </v-card-text>
    <v-card-actions>
      <div>
        <v-btn text color="grey darken-3" @click="passwordReset = true"
          >reset password</v-btn
        >
        <v-btn
          text
          color="grey darken-3"
          v-if="errors.detail"
          @click="resendEmail"
          >resend activation</v-btn
        >
      </div>
      <v-spacer></v-spacer>
      <v-btn
        type="submit"
        color="primary"
        :disabled="submitted"
        :block="blockButton"
        :text="textButton"
        >Login</v-btn
      >
    </v-card-actions>
  </v-form>
  <v-form
    v-else
    @submit.prevent="handlePasswordReset"
    :errorMessages="passwordResetErrors.detail"
  >
    <v-alert v-if="passwordEmailSent" dense text type="success"
      >If the email you entered is associated with a valid account you will
      receive an email shortly.</v-alert
    >
    <v-card-title class="headline" primary-title>Reset Password</v-card-title>
    <v-card-text>
      <v-text-field
        v-model="username"
        prepend-icon="mdi-account"
        name="email"
        label="Email"
        type="text"
        :outlined="outlined"
        :dense="dense"
        :errorMessages="passwordResetErrors.username"
      ></v-text-field>
    </v-card-text>
    <v-card-actions>
      <v-btn text color="grey darken-3" @click="passwordReset = false"
        >login</v-btn
      >
      <v-spacer></v-spacer>
      <v-btn
        type="submit"
        color="primary"
        :disabled="submitted"
        :block="blockButton"
        :text="textButton"
        >submit</v-btn
      >
    </v-card-actions>
  </v-form>
</template>

<script>
import { resendActivationEmail, resetPassword } from "@/services/api/auth";
import { mapActions } from "vuex";

export default {
  name: "LoginForm",
  props: {
    outlined: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    blockButton: {
      type: Boolean,
      default: false,
    },
    textButton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      username: process.env.VUE_APP_DEVELOPMENT ? "test@test.com" : "",
      password: process.env.VUE_APP_DEVELOPMENT ? "T3sting1234" : "",
      submitted: false,
      errors: {},
      passwordResetErrors: {},
      passwordReset: false,
      emailSent: false,
      passwordEmailSent: false,
    };
  },
  computed: {
    nextPath() {
      if ("next" in this.$route.query) {
        return this.$route.query.next;
      } else {
        return "/dashboard";
      }
    },
  },
  methods: {
    ...mapActions("auth", ["login", "getProfile"]),
    resendEmail() {
      resendActivationEmail(this.username)
        .then(() => {
          this.emailSent = true;
        })
        .catch(() => {
          this.emailSent = true;
        });
    },
    handleLogin() {
      this.submitted = true;
      this.login({
        username: this.username,
        password: this.password,
      })
        .then(() => {
          if (this.$route.path == "/login") {
            this.$router.push(this.nextPath);
          }
        })
        .catch((err) => {
          this.errors = err.response.data;
          this.submitted = false;
        });
    },
    handlePasswordReset() {
      resetPassword(this.username)
        .then(() => {
          this.passwordEmailSent = true;
        })
        .catch(() => {
          this.passwordEmailSent = true;
        });
    },
  },
};
</script>

<style></style>
